<template>
	<div class="app-user user-watches">
		<div class="header">
			<h1>{{ title }}</h1>
			<div class="btn-group" v-if="isPatientsRoute">
				<button-native-icon-text
					v-check-user:patients_add_group="user_uid"
					icon="plus-w"
					class="plus btn-add"
					@click.native="onButtonClick(TYPE_GROUP)">
					{{ $t('buttons.actions.add_group') }}
				</button-native-icon-text>
				<button-native-icon-text
					v-check-user:patients_add_patient="user_uid"
					icon="plus-w"
					class="plus btn-add"
					@click.native="onButtonClick(TYPE_PATIENT)">
					{{ $t('buttons.actions.add_patient') }}
				</button-native-icon-text>
			</div>
			<div class="btn-group" v-if="isDevicesRoute">
				<button-native-icon-text
					v-check-user:devices_add_group="user_uid"
					icon="plus-w"
					class="plus btn-add"
					@click.native="onButtonClick(TYPE_GROUP)">
					{{ $t('buttons.actions.add_group') }}
				</button-native-icon-text>
				<button-native-icon-text
					v-check-user:devices_add_device="user_uid"
					icon="plus-w"
					class="plus btn-add"
					@click.native="onButtonClick(TYPE_DEVICE)">
					{{ $t('buttons.actions.add_device') }}
				</button-native-icon-text>
			</div>
		</div>
		<div class="body">
			<router-view/>
		</div>
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="modalBox.title" :subHeader="title">
			<form-group   v-if="isModalType(TYPE_GROUP)"   @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :group_id="modalBox.model_id" :type="groupFormType"/>
			<form-patient v-if="isModalType(TYPE_PATIENT)" @done="onFormDone" :user_uid="user_uid" :action="modalBox.action"/>
			<form-device  v-if="isModalType(TYPE_DEVICE)"  @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :device_id="modalBox.model_id"/>
		</modal-box>
	</div>
</template>

<script>
import FormTypes from './watches/FormTypes'
import Navigation from './watches/UserWatchesNavigation'
import FormGroup from './watches/UserWatchesFormGroup'
import FormPatient from './watches/UserWatchesFormPatient'
import FormDevice from './watches/UserWatchesFormDevice'
export default {
	components: {
		Navigation,
		FormGroup,
		FormPatient,
		FormDevice
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			TYPE_GROUP: FormTypes.GROUP,
			TYPE_PATIENT: FormTypes.PATIENT,
			TYPE_DEVICE: FormTypes.DEVICE,
			modalBox: {
				open: false,
				action: '',
				model_id: '',
				type: '',
				title: ''
			}
		}
	},
	computed: {
		title () {
			switch (this.$route.name) {
				case 'UserWatchesPatients':
					return this.$t('base.general.patients')
				case 'UserWatchesDevices':
					return this.$t('base.general.devices')
				default:
					return '(error)'
			}
		},
		groupFormType () {
			switch (this.$route.name) {
				case 'UserWatchesPatients':
					return FormTypes.PATIENT
				case 'UserWatchesDevices':
					return FormTypes.DEVICE
				default:
					return null
			}
		},
		isPatientsRoute () {
			return this.$route.name === 'UserWatchesPatients'
		},
		isDevicesRoute () {
			return this.$route.name === 'UserWatchesDevices'
		}
	},
	methods: {
		onButtonClick (type) {
			let open = true
			let action = 'add'
			switch (type) {
				case this.TYPE_GROUP:
					this.modalBox.title = this.$t('buttons.actions.add_group')
					break
				case this.TYPE_PATIENT:
					this.modalBox.title = this.$t('buttons.actions.add_patient')
					break
				case this.TYPE_DEVICE:
					this.modalBox.title = this.$t('buttons.actions.add_device')
					break
				default:
					action = ''
					type = null
					open = false
			}
			this.modalBox.action = action
			this.modalBox.type = type
			this.modalBox.open = open
		},
		onEditGroup (group_id) {
			this.modalBox.action = 'edit'
			this.modalBox.model_id = group_id
			this.modalBox.type = this.TYPE_GROUP
			this.modalBox.title = this.$t('buttons.actions.edit_group')
			this.modalBox.open = open
		},
		onEditDevice (device_id) {
			this.modalBox.action = 'edit'
			this.modalBox.model_id = device_id
			this.modalBox.type = this.TYPE_DEVICE
			this.modalBox.title = this.$t('buttons.actions.edit_device')
			this.modalBox.open = open
		},
		onModalBoxClose () {
			this.modalBox.action = ''
			this.modalBox.model_id = ''
			this.modalBox.type = ''
			this.modalBox.title = ''
			this.modalBox.open = false
		},
		onFormDone () {
			this.onModalBoxClose()
			this.$emit('reload')
		},
		isModalType (type) {
			return this.modalBox.type === type
		}
	},
	created () {
		this.$root.$on('editGroup', this.onEditGroup)
		this.$root.$on('editDevice', this.onEditDevice)
	},
	beforeDestroy () {
		this.$root.$off('editGroup', this.onEditGroup)
		this.$root.$off('editDevice', this.onEditDevice)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserWatches.vue